// Empresa ativa desta aba.
//
// Fica em memória porque o localStorage é compartilhado entre as abas: se outra
// aba trocar de empresa, esta continua enviando a empresa com que abriu (e o
// Layout avisa e recarrega) em vez de gravar na empresa errada. O localStorage só
// guarda a última escolha, para o reload e as abas novas.
const STORAGE_KEY = "companyId_ow";

function readStored() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (err) {
    return null;
  }
}

let activeCompanyId = readStored();

export function getActiveCompanyId() {
  return activeCompanyId;
}

export function setActiveCompanyId(companyId) {
  const next = String(companyId);
  const changed = next !== activeCompanyId;

  activeCompanyId = next;
  localStorage.setItem(STORAGE_KEY, next);

  // Estado da empresa anterior: o modo de visão depende do papel nela, e o cache
  // de contrato CLT é do colaborador naquela empresa.
  if (changed) {
    localStorage.removeItem("viewMode_ow");
    sessionStorage.removeItem("has_clt_ow");
  }
}

export function clearActiveCompany() {
  activeCompanyId = null;
  localStorage.removeItem(STORAGE_KEY);
}

// Avisa quando outra aba troca a empresa ativa ou faz logout (o localStorage.clear()
// do logout dispara o evento com key null). Devolve a função que remove o listener.
export function watchActiveCompanyChanges(onChange) {
  const handler = (event) => {
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    const stored = readStored();
    if (stored === activeCompanyId) return;
    onChange(stored);
  };
  window.addEventListener("storage", handler);
  return () => window.removeEventListener("storage", handler);
}

// Só caminho interno da própria aplicação: "//site.com" seria um open redirect.
export function safeReturnTo(value) {
  if (typeof value !== "string") return null;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return null;
  if (value.startsWith("/auth/")) return null;
  return value;
}
